<template>
  <div>
    <!-- Kawalan Pemajuan Menu -->
    <div
      class="kawalan-pemajuan-menu"
      :class="{ open: isKawalanPemajuanMenuOpen }"
    >
      <ul>
        <!--
          <li class="menu-header">
          <span>KAWALAN PEMAJUAN</span>
          </li> 
        -->
        <li>
          <RouterLink to="/kawalan-pemajuan">
            OSC 3.0 Plus
          </RouterLink>
        </li>
      </ul>
    </div>
    <div
      v-if="isKawalanPemajuanMenuOpen"
      class="overlay"
      @click="closeMenus"
    />
    <button
      v-if="!isKawalanPemajuanMenuOpen"
      class="kawalan-pemajuan-toggle-button"
      @click="toggleKawalanPemajuanMenu"
    >
      <span class="vertical-text">KAWALAN PEMAJUAN</span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isKawalanPemajuanMenuOpen = ref(false)

const toggleKawalanPemajuanMenu = () => {
  isKawalanPemajuanMenuOpen.value = !isKawalanPemajuanMenuOpen.value
  if (isKawalanPemajuanMenuOpen.value) {
    closeMainMenu()
  }
}

const closeMenus = () => {
  isKawalanPemajuanMenuOpen.value = false
  closeMainMenu()
}

const closeMainMenu = () => {
  // Emit event to close Main Menu
  const event = new CustomEvent('close-main-menu')

  window.dispatchEvent(event)
}

window.addEventListener('close-kawalan-pemajuan-menu', () => {
  isKawalanPemajuanMenuOpen.value = false
})
</script>

<style scoped>
/* Kawalan Pemajuan Menu */
.kawalan-pemajuan-menu {
  position: fixed;
  top: 30%;
  right: 0;
  width: 200px;
  height: auto;
  max-height: 70%;
  background-color: #312867;
  color: white;
  padding: 10px 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
  transform: translateX(100%);
  z-index: 1000;
  border-radius: 10px;
}

.kawalan-pemajuan-menu.open {
  transform: translateX(0);
}

.kawalan-pemajuan-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.kawalan-pemajuan-menu li {
  margin-bottom: 10px;
}

.kawalan-pemajuan-menu a,
.kawalan-pemajuan-menu router-link {
  color: white;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Kawalan Pemajuan Toggle Button */
.kawalan-pemajuan-toggle-button {
  position: fixed;
  top: 40%;
  right: -10px;
  transform: translateY(-50%);
  background-color: #312867;
  border: none;
  padding: 2px;
  border-radius: 5px 0 0 5px;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 100;
  transition: right 0.3s;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.kawalan-pemajuan-toggle-button .vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
